import { render, staticRenderFns } from "./SVC95000.vue?vue&type=template&id=0f706efd&"
import script from "./SVC95000.vue?vue&type=script&lang=js&"
export * from "./SVC95000.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports